import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";

const SummaryDataBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.alt,
  borderRadius: "1rem",
  boxShadow: "0.15rem 0.2rem 0.15rem rgba(0, 0, 0, 0.8)",
}));

export default SummaryDataBox;
